/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Severitydefect1Inputs */

const en_severitydefect1 = /** @type {(inputs: Severitydefect1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defect`)
};

const pt_severitydefect1 = /** @type {(inputs: Severitydefect1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defeito`)
};

/**
* | output |
* | --- |
* | "Defect" |
*
* @param {Severitydefect1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const severitydefect1 = /** @type {((inputs?: Severitydefect1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Severitydefect1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_severitydefect1(inputs)
	return pt_severitydefect1(inputs)
});
export { severitydefect1 as "severityDefect" }